export const DYNAMIC_FEATURE_ID_FIELD_NAME = "TRANSFORM_TOOL_ID";
export const EARTH_RADIUS = 6371008.8; // Mean Earth Radius in meters

export const DRAWER_WIDTH = 550;

export const PARCELLAIRE_SMALL_SCREEN_MAX_WIDTH = 1400;
export const PARCELLAIRE_SMALL_SCREEN_MAX_HEIGHT = 700;

export const PLOTMAP_DELETE_MAX_FEATURE_TOTAL_SIZE = 500; // in number of UUID in the body
export const PLOTMAP_SAVE_MAX_FEATURE_TOTAL_SIZE = 750000; // in character count

export const TRANSFORM_RANGE_ERROR =
    "Move not allowed since transform calculation impossible.";

export const UNKNOWN_TRANSFORM_ERROR =
    "An unknown error has occured. Please try again later.";

export const COORDINATE_DECIMAL_COUNT = 7;

export const GEOMAN_CUSTOM_TOGGLE_BUTTON_NAMES = Object.freeze({
    DISPLAY_BLUE_MODE: "displayBlueMode",
    HIDDEN_PLOT_MODE: "hiddenPlotMode",
    SINGLE_TARGET_MODE: "singleTargetMode",
    SHIFT_MODE: "shiftMode",
    LOCKED_SHAPE_MODE: "lockedShapeMode",
});

export const DYNAMIC_FEATURE_X_Y_FIELD_NAME = "HIPHEN_X_Y";

export const MAP_TILE_LAYERS = Object.freeze({
    SATELLITE: {
        name: "sat",
        mapbox: "satellite-streets-v12",
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        file: "/static/illustrations/tileLayers/sat.png",
    },
    OPEN_STREET_MAP: {
        name: "osm",
        mapbox: "streets-v12",
        url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
        file: "/static/illustrations/tileLayers/osm.png",
    },
    TOPO_MAP: {
        name: "topo",
        mapbox: "outdoors-v12",
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.png",
        file: "/static/illustrations/tileLayers/topo.png",
    },
    DARK: {
        name: "dark",
        mapbox: "dark-v12",
        url: "https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
        file: "/static/illustrations/tileLayers/dark.png",
    },
});

export const PROPERTY_TYPES = Object.freeze({
    CROP: { label: "Crop", value: "crop", type: "crop" },
    EXPERIMENT: { label: "Experiment", value: "experiment", type: "string" },
    ROW_COUNT: { label: "Row Count", value: "row_count", type: "float" },
    AZYMUTH: { label: "Row Azimuth", value: "row_azimuth", type: "float" },
    MODALITY: { label: "Modality", value: "modality", type: "string" },
    VARIETY: {
        label: "Control Variety",
        value: "control_variety",
        type: "string",
    },
    SOWING_DENSITY: {
        label: "Sowing Density (m)",
        value: "sowing_density_m",
        type: "float",
    },
    DISTANCE_THRESHOLD: {
        label: "Distance Threshold (m)",
        value: "distance_threshold_m",
        type: "float",
    },
    CUSTOM: { label: "Custom Property", value: "custom", type: "string" },
});

export const PARCELLAIRE_TAB_BOX_STYLE = Object.freeze({
    p: (theme) => theme.spacing(3, 0, 0, 0),
});

export const PARCELLAIRE_BUTTON_STYLE = Object.freeze({
    textTransform: "none",
});
// Toolbar only: fixed-size controls so the bar scrolls
// horizontally instead of squeezing them.
export const PARCELLAIRE_TOOLBAR_BUTTON_STYLE = Object.freeze({
    ...PARCELLAIRE_BUTTON_STYLE,
    whiteSpace: "nowrap",
    flexShrink: 0,
});

export const RADIOMETRIC_TARGET_NAMES = Object.freeze({
    RADIOMETRIC_TARGET_2025: "radiometric_target_2025",
    RADIOMETRIC_TARGET_2024: "radiometric_target_2024",
    RADIOMETRIC_TARGET_2022: "radiometric_target_2022",
    RADIOMETRIC_TARGET_GRYFN11: "radiometric_target_gryfn11",
    RADIOMETRIC_TARGET_GRYFN30: "radiometric_target_gryfn30",
    RADIOMETRIC_TARGET_GRYFN56: "radiometric_target_gryfn56",
    RADIOMETRIC_TARGET_GRYFN82: "radiometric_target_gryfn82",
    RADIOMETRIC_TARGET_QUANTOMICS: "radiometric_target_quantomics",
});
